import { gql } from 'graphql-request';

import type { CurrencyISO } from '@/constants/currencies';
import type { CountryISO } from '@/constants/countries';

type AggregatePortfolioAnalysis = {
  value: number | null;
  roi: number | null;
  roiValue: number | null;
  holdingsCount: number;
  capitalInvested: number | null;
  currencyISO: CurrencyISO | null;
  marketCountryISO: CountryISO | null;
  estimatedYearlyDividend: number | null;
  estimatedDividendYield: number;
  isAnalysisRestricted: boolean;
  risksCount: number | null;
  rewardsCount: number | null;
};

type Snowflake = {
  scores: {
    value: number | null;
    future: number | null;
    past: number | null;
    health: number | null;
    dividend: number | null;
  };
};

export interface AggregatePortfolioFragmentType {
  analysis: AggregatePortfolioAnalysis;
  snowflake: Snowflake;
}

export const AGGREGATE_PORTFOLIO_FRAGMENT = gql`
  fragment aggregatePortfolioFields on AggregatePortfolio {
    analysis {
      value
      roi
      roiValue
      holdingsCount
      capitalInvested
      currencyISO
      marketCountryISO
      estimatedYearlyDividend
      estimatedDividendYield
      isAnalysisRestricted
      risksCount
      rewardsCount
    }
    snowflake {
      scores {
        value
        dividend
        future
        health
        past
      }
    }
  }
`;
